import { useTranslation } from 'react-i18next';
import type { TripSummary } from '../../types';
import { flagEmoji } from '../../utils/countries';

/** ADR-0045: the trip in numbers. A figure the server didn't send is not shown. */
export default function TripSummaryStrip({ summary }: { summary: TripSummary }) {
  const { t } = useTranslation();
  const items: { key: string; value: number | string; label: string }[] = [
    { key: 'days', value: summary.days, label: t('stats.days', { count: summary.days }) },
    { key: 'stops', value: summary.stops, label: t('stats.stops', { count: summary.stops }) },
  ];
  if (summary.km !== null) items.push({ key: 'km', value: summary.km.toLocaleString(), label: t('stats.km') });
  if (summary.photos !== null) items.push({ key: 'photos', value: summary.photos, label: t('stats.photos', { count: summary.photos }) });
  if (summary.entries !== null) items.push({ key: 'entries', value: summary.entries, label: t('stats.entries', { count: summary.entries }) });

  return (
    <div className="flex flex-wrap items-end gap-x-6 gap-y-3">
      {items.map(item => (
        <div key={item.key}>
          <p className="font-serif text-2xl font-semibold text-slate-900 dark:text-slate-100 tabular-nums leading-none">{item.value}</p>
          <p className="font-mono text-[10px] tracking-[0.12em] uppercase text-slate-400 mt-1">{item.label}</p>
        </div>
      ))}
      {summary.countries.length > 0 && (
        <p className="text-2xl leading-none" aria-label={t('stats.countries', { count: summary.countries.length })}>
          {summary.countries.map(flagEmoji).join(' ')}
        </p>
      )}
    </div>
  );
}
